import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import PageTitle from '../PageTitle/PageTitle';
import BreadCrumb from './BreadCrumb';
import actions from '../../actions/BreadCrumbNavAction';
import SiteComponent from '../SiteComponent/SiteComponent';

// TODO :: Enhance this component as required
export class BreadCrumbNav extends SiteComponent {
    static propTypes = {
        /**
         * breadcrumbs array
         * @type {Array}
         */
        breadCrumbs: PropTypes.arrayOf(PropTypes.object),
        softRoute: PropTypes.bool,
        minLengthOfCrums: PropTypes.number,
        theme: PropTypes.string,
        showJCPenneyCrumb: PropTypes.bool,
    };

    static defaultProps = {
        breadCrumbs: [],
        softRoute: false,
        minLengthOfCrums: 0,
        theme: '',
        showJCPenneyCrumb: true,
    };

    /* istanbul ignore next */
    componentWillReceiveProps(nextProps) {
        if (this.props.nTypeId !== nextProps.nTypeId) {
            this.callAction(nextProps.nTypeId, nextProps.breadCrumbs);
        }
    }

    hydrateOnMount() {
        this.callAction();
    }

    callAction(ntype = null, breadCrumbInfo = null) {
        const nId = ntype || this.props.nTypeId;
        const breadcrumbObj = breadCrumbInfo || this.props.breadCrumbs;
        const payload = this.props.nTypeId ? { urlState: nId } : null;
        if (!breadcrumbObj.length) {
            this.props.actions.getBreadCrumbsAction(payload);
        }
    }

    shouldComponentUpdate(nextProps) {
        return this.props.breadCrumbs !== nextProps.breadCrumbs;
    }

    render() {
        const isCenterTheme =
            this.props.theme === 'center'
                ? dt([
                      'overflow-auto',
                      'lg:overflow-hidden',
                      'w-full',
                      'text-center',
                      'font-open-sans',
                  ])
                : null;
        return (
            <div className={isCenterTheme}>
                <PageTitle />
                <BreadCrumb
                    breadCrumbs={this.props.breadCrumbs}
                    softRoute={this.props.softRoute}
                    minLengthOfCrums={this.props.minLengthOfCrums}
                    showJCPenneyCrumb={this.props.showJCPenneyCrumb}
                    theme={this.props.theme}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    breadCrumbs: state.breadCrumbsData,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BreadCrumbNav);
